import React from 'react'
import { Link } from 'react-router-dom'

/** Страница выплаты: единственный маршрут, на который ведёт токен выплаты. */
export const payoutTicketInfoUrl = (token: string): string =>
  '/payout-tickets/ticket-info/' + token

type Props = {
  /** Токен выплаты. Пусто — прочерк, ссылки нет. */
  token?: string | null
  className?: string
  /** Что показать вместо пустого токена. */
  empty?: React.ReactNode
}

/**
 * Токен выплаты в списках, отчётах и журналах: всегда ссылка на страницу этой выплаты,
 * открывается в новой вкладке.
 *
 * Клик не всплывает: токен часто стоит в строке-аккордеоне, и переход по ссылке не должен
 * сворачивать или раскрывать строку. Ссылка ставится только на токен выплаты — токен
 * депозита этим компонентом не рисуется, у него нет страницы выплаты.
 */
export const PayoutTokenLink: React.FC<Props> = ({ token, className, empty = '-' }) => {
  if (!token) return <>{empty}</>

  return (
    <Link
      to={payoutTicketInfoUrl(token)}
      target='_blank'
      className={className ?? 'text-primary'}
      onClick={(e) => e.stopPropagation()}
    >
      {token}
    </Link>
  )
}

export default PayoutTokenLink
